import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Card } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 10,
    background: "#1B75BC",
    color: "white",
    fontSize: 16,
    fontWeight: "bolder",
    minHeight: 40,
    width: "100%",
    lineHeight: 3,
  },
  label1: {
    marginLeft: 80,
  },
  label2: {
    marginLeft: 30,
    width: "100%",
  },
}));

export const TotalHours = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Card className={classes.container}>
      <span className={classes.label1}>Activity Hours</span>
      <span className={classes.label2}>{props.activityHours}</span>
      <span className={classes.label1}>Meal Hours</span>
      <span className={classes.label2}>{props.mealHours}</span>
      <span className={classes.label1}>{t("pgReview.totalHours")}</span>
      <span className={classes.label2}>{props.hours}</span>
    </Card>
  );
};

TotalHours.propTypes = {
  hours: PropTypes.any,
};

export default TotalHours;
